<template>
  <b-container
    fluid
    style="height: calc(100vh - 75px); overflow-y: auto"
  >
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-breadcrumb style="background-color: #f8f9fa">
        <b-breadcrumb-item to="/dashboard">
          <b-icon
            icon="house-fill"
            scale="1.25"
            shift-v="1.25"
            aria-hidden="true"
          />&nbsp;{{$t("dashboard")}}
        </b-breadcrumb-item>
        <b-breadcrumb-item
          active
          style="text-transform: capitalize"
        >{{$t(this.$store.state.selectedTaskType.toLowerCase())}} </b-breadcrumb-item>
        <!-- <b-breadcrumb-item to="#">Foo</b-breadcrumb-item> -->
      </b-breadcrumb>
      <h2
        class="mb-4"
        style="text-transform: capitalize"
      >
        {{$t(this.$store.state.selectedTaskType.toLowerCase())}} {{$t("forms")}} {{$t("tasks")}}
      </h2>
      <b-row>
        <b-col
          cols="4"
          v-for="(tasks, tasksIndex) in employeeTasks"
          :key="tasksIndex"
          v-b-tooltip.hover.bottom="tasks.parent_task && tasks.parent_task.task_status != null && tasks.parent_task.task_status == 0 ? 'Please complete '+ tasks.parent_task.task_title + ' first.' : ''"
          :class="tasks.parent_task && tasks.parent_task.task_status != null && tasks.parent_task.task_status != 4 ? 'disabledDiv' : (tasks.task_status && tasks.form_type && tasks.form_type == 4 && tasks.task_status == 4 ? 'nonClickable' : '')"
        >
          <div @click="setUserTaskUrl(tasks)">
            <b-card
              bg-variant="default"
              class="mb-4 click-cursor card-wrapper"
            >
              <!-- style="height: 20.4rem" -->
              <b-card-text class="my-4">
                <font-awesome-icon
                  icon="file-signature"
                  size="8x"
                  style="color: #3ddc97"
                />
              </b-card-text>
              <b-card-text class="text-dark">
                <b>{{ tasks.task_title }}</b>
              </b-card-text>
              <b-card-text>
                <b-badge
                  v-if="tasks.task_status == '0'"
                  variant="info"
                >{{$t("btnOpenText")}}</b-badge>
                <b-badge
                  v-if="tasks.task_status == '1'"
                  variant="warning"
                >{{$t("questionnaires.batchInProgressText")}}</b-badge>
                <b-badge
                  v-if="tasks.task_status == '2'"
                  variant="danger"
                >{{$t("hold")}}</b-badge>
                <b-badge
                  v-if="tasks.task_status == '3'"
                  variant="dark"
                >{{$t("training.review")}}</b-badge>
                <b-badge
                  v-if="tasks.task_status == '4'"
                  variant="success"
                >{{$t("training.complete")}}</b-badge>
              </b-card-text>
              <b-card-text>
                <b-button
                  v-if="tasks.task_status == '0'"
                  @click="setUserTaskUrl(tasks)"
                  variant="outline-info"
                >{{$t("startBtnText")}}</b-button>
                <b-button
                  v-else-if="tasks.task_status == '1'"
                  @click="setUserTaskUrl(tasks)"
                  variant="outline-warning"
                >{{$t("continueBtnText")}}</b-button>
              </b-card-text>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import { Helper } from "../../helpers";
export default {
  name: "EmployeeTasks",
  data () {
    return {
      isLoading: false,
      employeeTasks: []
    };
  },
  mounted () {
    this.$store.state.selectedTaskType = this.$route.params.taskType;
    localStorage.setItem( "selected_task_type", this.$store.state.selectedTaskType );
    this.getEmployeeTasks();
  },
  methods: {
    async getEmployeeTasks () {
      let employeeId = localStorage.getItem( "employeeId" );
      this.isLoading = true;
      this.employeeTasks = [];
      let response = await HTTP(
        "get",
        "api/v1/onboarding/employee/new/tasks/" +
        employeeId +
        "/" +
        this.$store.state.selectedTaskType,
        +null
      );
      try {
        if ( response && response.data ) {
          this.employeeTasks = response.data;
        }
        this.isLoading = false;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      }
    },
    setUserTaskUrl ( tasks ) {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "taskFormData" );
      localStorage.removeItem( "activeTaskStatus" );

      localStorage.setItem( "taskId", tasks.id );
      if (
        tasks.form_type == 1 ||
        tasks.form_type == 8 ||
        tasks.form_type == 10
      ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", tasks.id );
        this.$router.push( "/emplyee-user-form/" + tasks.id + "/1" );
      } else if ( tasks.form_type == 3 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", tasks.id );
        this.$router.push( "/emplyee-training/" + tasks.id + "/1" );
      } else if ( tasks.form_type == 6 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", tasks.id );
        this.$router.push( "/employee-pdf-training/" + tasks.id + "/1" );
      } else if ( tasks.form_type == 4 ) {
        localStorage.setItem( "taskId", tasks.id );
        this.getTaskForm( tasks.id );
      } else if ( tasks.form_type == 11 ) {
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", tasks.id );
        /* 
          28May2024
          https://ethixbase.atlassian.net/browse/EB2-52720
          https://ethixbase.atlassian.net/browse/EB2-52719
        */
        if(tasks.task_status != '4')
          this.$router.push( "/emplyee-training-exam/" + tasks.id + "/1" );
      }
    },
    makeToster ( tosterVarient, tosterMsg ) {
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    async getTaskForm ( taskId ) {
      this.formButtom = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: taskId,
          formType: 4,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if(result){
        if(result.data){
          if ( result.data.task ) {
            if ( result.data.task.language ) {
              this.$store.state.selectedLanguage = result.data.task.language.toLowerCase();
              this.$i18n.locale = result.data.task.language.toLowerCase();
            }
            let form = result.data.task.schema;
            if ( result.data.task.parent_task && result.data.task.parent_task.task_status ) {
              if ( result.data.task.parent_task.task_status != 4 ) {
                this.makeToster( 'warning', 'Please complete ' + result.data.task.parent_task.task_title + ' first.' );
                return;
              }
            }
            let form_data = JSON.parse( result.data.task.form_data );
            this.$store.state.userFormSubmitArray = form_data;
            localStorage.setItem( "activeFormSchema", form );
            localStorage.setItem( "activeTaskStatus", result.data.task.task_status );
            localStorage.setItem(
              "examAttemptsToDate",
              result.data.task.exam_attempts_count
            );

            this.$router.push( "/emplyee-user-exam/" + taskId + "/1" );
          }
        }
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../assets/styles/theme1/badge.css";
</style>

<style>
.disabledDiv {
  pointer-events: none;
  opacity: 0.4;
}
.nonClickable {
  pointer-events: none;
}
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>